import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Trophy, Users, TrendingUp } from "lucide-react";
import { Progress } from "@/components/ui/progress";

interface ClassStats {
  classId: string;
  title: string;
  instructor: string;
  totalSubscriptions: number;
  attendanceRate: number;
}

interface PopularClassesProps {
  classes: ClassStats[];
}

export const PopularClasses = ({ classes }: PopularClassesProps) => {
  const maxSubscriptions = Math.max(...classes.map(c => c.totalSubscriptions), 1);

  return (
    <Card className="border-border/50 bg-card/50 backdrop-blur-sm">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg flex items-center gap-2">
          <Trophy className="h-5 w-5 text-yellow-500" />
          Clases Populares
        </CardTitle>
      </CardHeader>
      <CardContent>
        {classes.length === 0 ? (
          <p className="text-muted-foreground text-sm py-4 text-center">
            No hay clases registradas
          </p>
        ) : (
          <div className="space-y-4">
            {classes.map((cls, index) => (
              <div key={cls.classId} className="space-y-2">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="h-8 w-8 rounded-full bg-primary/10 flex items-center justify-center text-sm font-bold text-primary">
                      {index + 1}
                    </div>
                    <div>
                      <p className="font-medium text-foreground">{cls.title}</p>
                      <p className="text-xs text-muted-foreground">{cls.instructor}</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-4 text-sm">
                    <div className="flex items-center gap-1 text-muted-foreground">
                      <Users className="h-4 w-4" />
                      {cls.totalSubscriptions}
                    </div>
                    <div className="flex items-center gap-1 text-green-500">
                      <TrendingUp className="h-4 w-4" />
                      {cls.attendanceRate.toFixed(0)}%
                    </div>
                  </div>
                </div>
                <Progress 
                  value={(cls.totalSubscriptions / maxSubscriptions) * 100} 
                  className="h-2"
                />
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};
